import { FileQuestion } from "lucide-react";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";

interface NotFoundProps {
  title?: string;
  description?: string;
  showBackButton?: boolean;
}

export function NotFound({
  title = "Page Not Found",
  description = "Sorry, the page you are looking for doesn't exist or has been moved.",
  showBackButton = true
}: NotFoundProps) {
  const navigate = useNavigate();

  return (
    <div className="flex h-[70vh] w-full flex-col items-center justify-center p-6 text-center">
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-muted">
        <FileQuestion className="h-12 w-12 text-muted-foreground" />
      </div>
      <h2 className="mt-5 text-2xl font-semibold text-foreground">{title}</h2>
      <p className="mt-2 max-w-md text-muted-foreground">{description}</p>
      {showBackButton && (
        <div className="mt-6 flex gap-4">
          <Button onClick={() => navigate(-1)} variant="outline">
            Go Back
          </Button>
          <Button onClick={() => navigate("/")}>
            Go Home
          </Button>
        </div>
      )}
    </div>
  );
} 